import { IPersonaProps } from "@fluentui/react";
import authModule from "../../../utilities/AuthModule";
import { getSharePointSiteUsers } from "./SharePointRestServices";
import { validateEmail } from "../components/helpers/validateEmail";

export class PeopleCompositeServices {
  constructor(private webUrls: string[]) { }
  async getAllUsers(): Promise<IPersonaProps[]> {
    const accessToken = await authModule.getSharePointAccessToken();

    const users = await Promise.all(
      this.webUrls.map(async webUrl => {
        let users = await getSharePointSiteUsers(accessToken, webUrl);
        if (Array.isArray(users) && users.length > 0) {
          return users
            .map(item => {
              let secondaryText: string;
              if (item.Email) {
                secondaryText = item.Email;
              }
              else if (validateEmail(item.UserPrincipalName)) {
                secondaryText = item.UserPrincipalName;
              }

              return secondaryText
                ? { text: item.Title, id: item.Id, secondaryText }
                : null;
            })
            .filter(usr => usr);
        }
        return [];
      })
    );

    return users.reduce((agg, current) => [...agg, ...current], []);
  }
}
